<template>
<div class="col-md-12" v-loading="isLoading">
  <div class="card">
    <form>
      <div class="card-header">
        <h4 class="card-title">{{ title }}</h4>
      </div>
      <div class="card-content">
        <div
          class="row form-group"
        >
          <div class="col-md-4">
            <label>Status do evento</label>
            <div>
              <el-select
                size="xlarge"
                filterable
                class="select-primary"
                placeholder="Selecione um status"
                v-model="model.status"
              >
                <el-option
                  v-for="option in statusOptions"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-6">
            <label>Município</label>
            <br/>

            <el-select
              name="city"
              filterable
              class="select-primary"
              size="large"
              placeholder="Selecione..."
              v-model="model.city"
            >
              <el-option
                v-for="item in citiesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <small
              class="text-danger"
              v-show="city.invalid"
            >{{ getError('city') }}
            </small>
          </div>
        </div>

        <div class="form-group">
          <label>Link do sorteio online</label>
          <input
            v-model="model.prizeLink"
            type="text"
            name="prizeLink"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label>Referência</label>
          <input
            v-model="model.reference"
            v-validate="modelValidations.reference"
            type="text"
            name="reference"
            placeholder="Ex: Praia de Iracema - Março/2018"
            class="form-control"
          />
          <small
            class="text-danger"
            v-show="reference.invalid"
          >{{ getError('reference') }}
          </small>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Data de Início</label>
            <div>
              <el-date-picker
                v-validate="modelValidations.startDate"
                v-model="model.startDate"
                type="date"
                placeholder="Escolha uma data"
                format="dd/MM/yyyy"
                :clearable="false"
                :editable="false"
              ></el-date-picker>
            </div>
            <small
              class="text-danger"
              v-show="startDate.invalid"
            >{{ getError('startDate') }}
            </small>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Data Fim</label>
            <div>
              <el-date-picker
                name="endDate"
                v-validate="modelValidations.endDate"
                v-model="model.endDate"
                type="datetime"
                placeholder="Escolha uma data"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                :editable="false"
              ></el-date-picker>
            </div>
            <small
              class="text-danger"
              v-show="endDate.invalid"
            >{{ getError('endDate') }}
            </small>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Data e hora da cerimônia</label>
            <div>
              <el-date-picker
                name="dateTimeCeremony"
                v-validate="modelValidations.dateTimeCeremony"
                v-model="model.dateTimeCeremony"
                type="datetime"
                placeholder="Escolha uma data"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                :editable="false"
              ></el-date-picker>
            </div>
            <small
              class="text-danger"
              v-show="dateTimeCeremony.invalid"
            >{{ getError('dateTimeCeremony') }}
            </small>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Data e hora da entrega das geladeiras</label>
            <div>
              <el-date-picker
                name="dateTimeDelivery"
                v-validate="modelValidations.dateTimeDelivery"
                v-model="model.dateTimeDelivery"
                type="datetime"
                placeholder="Escolha uma data"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                :editable="false"
              ></el-date-picker>

              <span style="margin-left: 1em; margin-right: 1em;">às</span>

              <el-time-select
                name="timeEndDelivery"
                v-validate="modelValidations.timeEndDelivery"
                v-model="model.timeEndDelivery"
                :picker-options="{ start: '06:00', step: '00:30', end: '23:59' }"
                placeholder="Selecione a hóra de término da entrega"
                :clearable="false"
                :editable="false"
              ></el-time-select>
            </div>
            <small
              class="text-danger"
              v-show="dateTimeDelivery.invalid"
            >{{ getError('dateTimeDelivery') }}
            </small>
          </div>
        </div>

        <div
          v-if="config.registerCustomerTicketDocument"
          class="form-group"
        >
          <label for="form-deliveryAddress">Endereço de entrega da geladeira</label>
          <input
            id="form-deliveryAddress"
            type="text"
            class="form-control"
            v-model="model.deliveryAddress"
          >
          <small>Este endereço será exibido no documento de cadastro do cliente.</small></div>

        <div class="form-group">
          <label for="form-numberOfRefigerators">Quantidade de geladeiras</label>
          <input
            id="form-numberOfRefigerators"
            type="number"
            min="0"
            name="numberOfRefigerators"
            v-validate="modelValidations.numberOfRefigerators"
            v-model="model.numberOfRefigerators"
            class="form-control"
            :readonly="model.drawn"
          />
          <small
            class="text-danger"
            v-show="numberOfRefigerators.invalid"
          >{{ getError('numberOfRefigerators') }}
          </small>
          <small
            v-if="model.drawn"
            class="text-info"
          >
            Sorteio já realizado, não é possível alterar a quantidade de geladeiras.
          </small>
        </div>


        <div class="form-group">
          <label>
            Os
            <strong>ganhadores</strong> são definidos através de uma
            <strong>lista</strong>?
          </label>
          <br/>
          <YesNoRadio v-model="model.directList"></YesNoRadio>
        </div>

        <div class="form-group">
          <p>
            Os clientes marcados para <strong>medição ganharão geladeira</strong> automaticamente?
          </p>
          <YesNoRadio v-model="model.energyDefaultWinner"></YesNoRadio>
        </div>

        <div
          class="form-group"
          v-if="haveSurveys"
        >
          <label>Como será efetuada a escolha do cliente ganhador?</label>
          <div class="radio">
            <input
              type="radio"
              id="event-radio-winner-lottery"
              value="lottery"
              v-model="model.winnerChoiceMode"
            />
            <label for="event-radio-winner-lottery">Sorteio</label>
            <br/>
            <input
              type="radio"
              id="event-radio-winner-ranking"
              value="ranking"
              v-model="model.winnerChoiceMode"
            />
            <label for="event-radio-winner-ranking">Ranking</label>
          </div>
        </div>

        <div
          v-if="model.winnerChoiceMode === 'ranking'"
          class="row"
        >
          <div class="col-xs-12">
            <label>
              Que tipo de pesquisas serão efetuadas neste projeto?
            </label>
          </div>
          <div
            class="col-xs-12 col-sm-2"
            v-for="(value, iterator) in Object.keys(surveysOptions)"
            :key="iterator"
          >
            <input
              class=""
              type="checkbox"
              :id="`su-${value}`"
              :value="value"
              :disabled="value === 'refrigerator'"
              v-model="model.surveysType"
            >
            {{ surveysOptions[value] }}
          </div>
          <div class="col-xs-12">
            <small class="help-block">
              Observação: Refrigerador é obrigatória.
            </small>
          </div>
        </div>

        <div v-if="config.event.managedCsv">
          <div class="row">
            <div class="col-md-6">
              <label>Os clientes serão registrados através de um CSV?</label>
              <YesNoRadio v-model="model.registerCustomerByCsv"></YesNoRadio>

            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Habilitar confirmar ganhadores através de um CSV?</label>
              <YesNoRadio v-model="model.confirmCustomerByCsv"></YesNoRadio>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Habilitar download do CSV dos ganhadores?</label>
              <YesNoRadio v-model="model.downloadWinnersCsv"></YesNoRadio>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Habilitar download do PPT dos ganhadores?</label>
              <YesNoRadio v-model="model.downloadWinnersPpt"></YesNoRadio>
            </div>
          </div>
        </div>
      </div>

      <LampEventConfigFormConmponent/>

      <DocumentsEventFormComponents
        :current-terms="termsOfState"
        :current-state="config.state"
      />

      <div class="card-footer text-right">
        <button
          v-if="$can('events.create|events.edit')"
          :disabled="saving"
          type="button"
          @click="handleSave()"
          class="btn btn-fill btn-success btn-wd"
        >Salvar
        </button>
      </div>
    </form>
  </div>
</div>
</template>
<script>
import { mapFields } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'

import swal from 'sweetalert2'

import YesNoRadio from '../../components/Trg/YesNoRadio'
import TagList from '../../components/Trg/Tags/ListTags'
import CompanyTermsRadios from 'src/components/Trg/CompanyTermsRadios'
import DocumentsEventFormComponents from '../../components/Trg/Event/DocumentsEventFormComponents'
import LampEventConfigFormConmponent from '../../components/Trg/Event/LampEventConfigFormConmponent'
import Couchdb from '../../services/Couchdb'
import CouchdbClass from 'src/services/CouchdbClass'
import LGPD from 'src/services/LGPD'

export default {
  components: {
    TagList,
    CompanyTermsRadios,
    DocumentsEventFormComponents,
    YesNoRadio,
    LampEventConfigFormConmponent
  },

  data () {
    return {
      saving: false,
      indexPath: { name: 'events.index' },
      entityName: 'Evento',
      formatted_address: '',
      defaultZoom: 15,
      mapPlace: null,
      marker: null,
      isLoading: false
    }
  },

  computed: {
    ...mapFields([
      'city',
      'reference',
      'place',
      'startDate',
      'endDate',
      'dateTimeCeremony',
      'dateTimeDelivery',
      'numberOfRefigerators',
      'numberOfLamps',
      'status',
      'directList',
      'registerCustomerByCsv',
      'confirmCustomerByCsv',
      'downloadWinnersCsv',
      'downloadWinnersPpt'
    ]),
    model: {
      get () {
        return this.$store.state.events.one
      }
    },
    ...mapGetters('events', {
      modelValidations: 'validations',
      loading: 'loading',
      statusOptions: 'statusOptions',
      surveysOptions: 'surveysOptions'
    }),
    ...mapGetters('project', {
      citiesOptions: 'citiesOptions',
      config: 'project',
      termsOfState: 'termsOfState'
    }),

    couchdbCustomers: function () {
      return new CouchdbClass({ connection: 'default', collection: 'customers' })
    },

    couchdbTickets: function () {
      return new CouchdbClass({ connection: 'default', collection: 'tickets' })
    },

    couchdbLamps: function () {
      return new CouchdbClass({ connection: 'default', collection: 'lamps' })
    },

    id () {
      return this.$route.params.id
    },

    editing () {
      return this.id !== undefined
    },

    title () {
      return this.editing ? `Editar ${this.entityName}` : `Novo ${this.entityName}`
    },

    haveSurveys: {
      get () {
        return this.config.haveSurveys
      }
    }
  },

  methods: {
    ...mapActions('events', [
      'fetchOne',
      'fetchViewOne',
      'resetOne',
      'insert',
      'upsertWithView',
      'upsert'
    ]),
    ...mapActions('customers', { upsertCustomer: 'upsert' }),
    ...mapActions('eventsSpecifications', { upsertSpecifications: 'upsert', findSpecification: 'fetchAll' }),

    ...mapActions('project', {
      fetchProject: 'fetchOne'
    }),

    getError (fieldName) {
      return this.errors.first(fieldName)
    },

    handleSave () {
      this.saving = true
      this.$validator
        .validateAll()
        .then(isValid => {
          if (isValid) {
            this.validSave()
          }
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.saving = false
        })
    },

    validSave () {
      const lastStatus = this.model.lastStatus
      const status = this.model.status

      delete this.model.lastStatus

      if (this.model.status === 2) {
        this.model.status = lastStatus || 0
      }

      this.upsert(this.model).then((result) => {
        if (this.editing) {
          this.$notify({
            message: 'Registro editado com sucesso.',
            type: 'success'
          })
        } else {
          this.model._id = result.id
          this.model._rev = result.rev

          this.$notify({
            message: 'Registro criado com sucesso.',
            type: 'success'
          })
        }

        if (status === 2 && status !== lastStatus && this.config.useLGPD) {
          this.isLoading = true
          swal({
            title: 'Finalizar Evento?',
            text: `Ao finalizar o evento, o processo poderá demorar alguns minutos`,
            type: 'warning',
            cancelButtonText: 'Cancelar',
            confirmButtonClass: 'btn btn-warning btn-fill mr',
            cancelButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: true,
            focusCancel: true
          }).then((result) => {
            if (result) {
              this.model.status = status
              this.removeSensitiveData().then(() => {
                this.updateEvent()
              })
                .catch(err => console.log(err))
                .finally(() => {
                  this.isLoading = false
                })
            }
          }).catch(() => {
            this.saveSpecification(result, this.model)
          })
        } else {
          if (status === 2 && !this.config.useLGPD) {
            this.model.status = status

            this.updateEvent()
          } else {
            this.saveSpecification(result, this.model)
          }
        }
      }).catch(err => console.log(err)).finally(() => {
        this.saving = false
      })
    },

    async removeSensitiveData () {
      const customers = []
      const tickets = await Couchdb.connection('default').collection('tickets').where('eventId', this.id).limit(99999999).get()
      const lampdas = await Couchdb.connection('default').collection('lamps').where('eventId', this.id).limit(99999999).get()

      let lamps = []

      for (let ticket of tickets) {
        const customersByTicket = await Couchdb.connection('default').collection('customers').where('_id', ticket.customerId).get()
        const customer = customersByTicket[0]
        if (customer && customers.filter(c => customer._id === c._id).length === 0) {
          if (ticket.winner) {
            customer.contemplated = true
            const novosDadosDoContemplado = this.hideCustomerData(customer)
            customers.push(novosDadosDoContemplado)
          } else {
            customers.push(customer)
            ticket.deletedAt = new Date()
          }
        }
      }

      // const contemplatedCustomers = customers.filter((customer) => customer.contemplated)
      for (let i = 0; i < customers.length; ++i) {
        let customer = customers[i]
        const customerLamps = await Couchdb.connection('default').collection('lamps').where('customer.id', customer._id).limit(99999999).get()

        if (customerLamps.length === 0 && !customer.contemplated) {
          customer._deleted = true
          continue
        }

        const novosDadosDoContemplado = this.hideCustomerData(customer)

        for (const index in customerLamps) {
          customerLamps[index].customer.holder = novosDadosDoContemplado.holder
          delete customerLamps[index].customer.cpf
        }

        lamps = [...lamps, ...customerLamps]

        customers[i] = novosDadosDoContemplado
        // contemplatedCustomers.push(novosDadosDoContemplado)
      }

      for (let i = 0; i < lampdas.length; ++i) {
        let lampda = lampdas[i]
        let customerLamp = await Couchdb.connection('default').collection('customers').where('_id', lampda.customer.id).first()

        if (customerLamp.contemplated) {
          continue
        }

        const novosDadosDoContemplado = this.hideCustomerData(customerLamp)

        lampda.customer.holder = novosDadosDoContemplado.holder
        delete lampda.customer.cpf

        lamps = [...lamps, ...lampda]

        customerLamp = novosDadosDoContemplado
        customers.push(customerLamp)
      }

      await this.couchdbLamps._updateBulkDocs(lamps)
      await this.couchdbTickets._updateBulkDocs(tickets)
      await this.couchdbCustomers._updateBulkDocs(customers)
      // await this.couchdbCustomers._updateBulkDocs(contemplatedCustomers)
    },

    getCustomersIn (tickets) {
      let select = ['_id', 'uc', 'cpf', 'nationalId', 'holder', 'aka', 'phones.0', 'address.street', 'address.number', 'address.neighborhood', 'address.city', 'address.zip', 'address.complement', 'observartion', 'nis', 'userId']
      let ticketsCustomersId = tickets.map(item => {
        return item.customerId
      })
      return Couchdb.connection('default').collection('customers').select(select).whereIn('_id', ticketsCustomersId).get()
    },

    updateEvent () {
      this.upsert(this.model).then(() => {
        swal({
          title: 'Sucesso',
          text: `Evento foi finalizado com sucesso`,
          type: 'success',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then((result) => {
          if (result) {
            this.saveSpecification(result, this.model)
          }
        })
      })
    },

    saveSpecification (result, doc) {
      this.findSpecification({ where: { eventId: result.id } })
        .then(spec => {
          let eventSpec = {}
          if (spec.length > 0) {
            eventSpec = Object.assign({}, spec[0])
          }

          eventSpec = Object.assign(eventSpec, {
            sourceDb: process.env.DB_NAME,
            eventId: doc._id,
            event: {
              city: doc.city,
              reference: doc.reference
            },
            gps: {
              latitude: '',
              longitude: ''
            },
            tags: {}
          })

          console.log(eventSpec)
          this.upsertSpecifications(eventSpec).then(() => {
            this.$router.push(this.indexPath)
          })
        })
    },

    hideCustomerData (customer) {
      const novosDadosDoContemplado = LGPD.removeCustomerSensitiveData(customer)
      return novosDadosDoContemplado
    }
  },

  mounted () {
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config')
    }

    if (this.$route.params.id) {
      this.fetchOne(this.$route.params.id).then(() => {
        this.model.lastStatus = this.model.status
      })
    } else {
      this.resetOne()
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/Events/EventsForm.vue